export const isInstanceRetrievalError = (error: unknown): boolean => error instanceof Error && /Could not find instance: .+ \(> \d+ ms\)/.test(error.message)
